import ajax from "../helpers/ajax";
import StoreContainer from "../stores/StoreContainer";

import { CallRequest, CallContent, Call } from "../types";

class CallService {
  static async requestCall(
    siteId: number,
    callRequest: CallRequest
  ): Promise<CallContent> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/call/requestcall/`,
      method: "post",
      data: callRequest
    });
  }
  static async requestDirectCall(
    siteId: number,
    callRequest: CallRequest
  ): Promise<CallContent> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/call/requestdirectcall/`,
      method: "post",
      data: callRequest
    });
  }
  static async loadCall(
    siteId: number,
    callRequest: CallRequest
  ): Promise<Call> {
    try {
      var call = await ajax({
        url: `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/${siteId}/call/connectcall/`,
        method: "post",
        data: callRequest
      });
      return call;
    } catch (ex) {
      return null;
    }
  }
}
export default CallService;
